import Fetcher from "../../../services/fetcher";
import settings from "../../../settings";

export const getArticleBySlug = (slug: any) => {
  return Fetcher.get(settings.servingApi + `/decryptages/${slug}`)
};